@use "variables" as *;

.shelf {
  display: flex;
  position: relative;
  box-sizing: border-box;
}
